<template>
  <div>
    <div style="width: 98%;">
      <div class="search-wrap">
        <el-button size="mini" type="primary text2" @click="search">搜索</el-button>
        <el-button size="mini" type="primary text2" v-if="ERP.isPermission(3004012001)" @click="exportExcel">导出</el-button>
        <el-button size="mini" type="primary text2" v-if="ERP.isPermission(3004012002)" @click="importExcel">导入</el-button>
        <el-descriptions :column="1" border>
          <el-descriptions-item size="mini" label="房产">
            <el-input size="mini" placeholder="请输入搜关键字" v-model="where.address" clearable style="width: 500px"></el-input>
          </el-descriptions-item>
          <el-descriptions-item size="mini" label="房态">
            <el-select size="mini" v-model="where.room_status_ids" placeholder="房态" @change="search()">
              <el-option
                v-for="(item,index) in room_status_list_2"
                :key="index"
                :value="item.id" :label="item.name">
                <span style="float: left">{{ item.name }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.count }}</span>
              </el-option>
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item size="mini" label="房产类型">
            <el-checkbox-group size="mini" v-model="where.house_type" style="width: 100%;" @change="search()">
              <el-checkbox label="1">住宅</el-checkbox>
              <el-checkbox label="4">商铺</el-checkbox>
              <el-checkbox label="5">写字楼</el-checkbox>
              <el-checkbox label="2">车位</el-checkbox>
              <el-checkbox label="3">储藏室</el-checkbox>
            </el-checkbox-group>
          </el-descriptions-item>
        </el-descriptions>



      </div>
      <div class="table-wrap">
        <el-table v-if="pageData" v-loading="loading" :data="pageData.list" height="70vh">
          <el-table-column prop="community_name" label="项目名称" width="180" align="center" ></el-table-column>
          <el-table-column prop="address" label="房产" align="center" min-width="320"></el-table-column>
          <el-table-column prop="customer_name" label="业主名称" width="180" align="center" ></el-table-column>

          <!--            <el-table-column prop="RoomStatus" label="新视窗房态" width="100" align="center"></el-table-column>-->
          <el-table-column prop="room_status_name" label="ERP房态" align="center" width="80"></el-table-column>

          <el-table-column prop="room_status" label="识别码" align="center" width="80"></el-table-column>
          <el-table-column label="操作" width="120" align="center">
            <template slot="default" slot-scope="scope">
              <el-button v-if="ERP.isPermission(3004012003)" @click="editRoomStatus(scope.row)">修改房态</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="pagination-wrap">
        <el-pagination background layout="prev, pager, next" :total="pageData.total*1" :page-size="pageData.pageSize*1" :current-page="pageData.page*1" @current-change="pageChange"></el-pagination>
      </div>
    </div>

    <el-dialog title="修改房态" width="550px" :visible.sync="dialogVisible">
      <div style="padding-left: 20px">
        <el-form>
          <el-form-item label="项目">
            {{form.community_name}}
          </el-form-item>
          <el-form-item label="房产">
            {{form.address}}
          </el-form-item>
          <el-form-item label="业主">
            {{form.customer_name}}
          </el-form-item>
          <el-form-item label="房态">
            <el-select size="mini" v-model="form.room_status" placeholder="房态">
              <el-option
                v-for="item in room_status_list"
                :key="item.id"
                :label="item.name"
                :value="item.code+''">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注">
            <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入备注"
              v-model="form.remarks">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button v-if="ERP.isPermission(3004012004)" @click="submitRoomStatus()">确认</el-button>
            <el-button @click="dialogVisible=false">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CommonHelp from "../../common/CommonHelp";
import SearchHouse from "../../../Common/search-house";

export default {
  name: "RoomStatusList",
  components: {
    SearchHouse
  },
  inject: ['mainObj'],
  data() {
    return {
      loading: false,
      where:{
        room_status_ids:0,
        address:"",
        house_type:['1','4','5'],
      },
      pageData:{
        list:[],
        total:0,
        pageSize:15,
        page:1
      },
      form:{
        remarks:""
      },
      room_status_list:[],
      room_status_list_2:[],
      dialogVisible:false,
    }
  },
  mounted() {
    this.where.address=this.mainObj.house_name;
    this.getRoomStatusList()
    this.search()
    this.getStatistics()
  },
  methods:{
    search() {
      this.pageData.page = 1
      this.getList()
    },
    nodeClick(data){
      this.where.address=data.tree.map(ret => {
        return ret.name
      }).join('->');
      this.search()
      this.getStatistics()
    },
    getList() {
      const that = this;
      let where=CommonHelp.reObject(this.where);
      if(where.address){
        that.loading=true;
        ERP.getRequest({url:"admin/RoomStatus/getList",data:{
            where:JSON.stringify(where),
            page: this.pageData.page,
            page_size: this.pageData.pageSize
          }
        },res=>{
          if(res.code) {
            that.pageData=res.data
          }
          that.loading=false;
        })
      }
    },
    getStatistics() {
      const that = this;
      let where=CommonHelp.reObject(this.where);
      if(where.address){
        ERP.getRequest({url:"admin/RoomStatus/getStatistics",data:{
            where:JSON.stringify(where)
          }
        },res=>{
          if(res.code) {
            that.room_status_list_2=res.data
          }
        })
      }
    },
    getRoomStatusList(){
      const that = this;
      ERP.getRequest({url:"admin/RoomStatus/getRoomStatusList"},res=>{
        if(res.code) {
          that.room_status_list=res.data
        }
      })
    },
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    editRoomStatus(item){
      this.form=CommonHelp.reObject(item);
      this.dialogVisible=true;
    },
    submitRoomStatus(){
      const that=this;
      ERP.getRequest({url:"admin/RoomStatus/updateRoomStatus",data:{
          house_id:that.form.id,
          room_status:that.form.room_status,
          remarks:that.form.remarks||'',
        }
      },res=>{
        if(res.code) {
          that.getList()
          that.getStatistics()
          that.dialogVisible=false;
          that.$message.success(res.msg||'保存成功')
        }else {
          that.$message.error(res.msg||'操作失败')
        }
      })
    },
    exportExcel(){
      const that = this;
      let where=CommonHelp.reObject(that.where);
      if(!where.address){
        that.$message.error('选择项目房产或输入')
        return false;
      }

      that.$confirm(`您确定导出的房态列表是 【${where.address}】 ？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let data = {
          targetController:"RoomStatusTask",
          targetFunction:"exportExcelTask",
          taskName:"房态导出",
          where:JSON.stringify(where),
        };

        ERP.postRequest({url:"admin/ExcelTask/addTask",data},ret=>{
          if(ret.code===200){
            that.$message.success("报表生成中……");
          }else {
            that.$message.error("数据拉取失败");
          }
        },err=>{
          that.$message.error("数据请求异常");
        })


      }).catch(() => {
      });
    },
    importExcel(){
      const that = this;
      that.$confirm('您将操作导入房态，下一步将启动选择文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.loading=true;
        CommonHelp.uploadFile(ret=>{
          console.log(ret);
          ERP.postRequest({url:"admin/RoomStatus/importExcel",data:{
              file:ret
            }
          },res=>{
            if(res.code) {
              that.$message.success(res.msg||'导入成功');
              that.getStatistics()
              that.getList();
            }else {
              this.$message.error(res.msg||'导入失败');
            }
            that.loading=false;
          })
        });
      }).catch(() => {

      });

    }
  },
  watch:{
    "mainObj.house_name":function(val){
      this.where.address=val;
      this.search()
      this.getStatistics()
    }
  }
}
</script>

<style lang="scss" scoped>
.el-button--primary,.el-button--success,.el-button--danger,.el-button--warning {
  color: #FFF;
}
.text1{
  text-align: center;
}
.pages{
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}
.search{
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}
.text2{
  color: rgb(250, 248, 248);
}
.kuan{
  width: 10%;
}
.zhanwu{
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}
.pagination-wrap{
  margin-top: 20px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/HouseCode/components/room-status/RoomStatusList.vue